import React from 'react';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';

import './LoaderContainer.css';

const LoaderContainer = ({ loading }) =>
  loading ? (
    <div className="Loader-container">
      <CircularProgress size={56} thickness={6} />
    </div>
  ) : null;

export default connect(({ loader: { loading } }) => ({ loading }))(LoaderContainer);



// WEBPACK FOOTER //
// ./src/containers/private/LoaderContainer.js